/* eslint-disable react/require-default-props */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Flex, Pane } from '@leverege/ui-elements';
import { connect } from 'react-redux';
import useTwoFactorEnroll from "./hooks/useTwoFactorEnroll.js";
import { TWO_FACTOR_ENROLL_STEPS, TwoFacterEnrollDefaultProps } from "./Constants.js";
import S from './Login.css';
import TwoFacterEnrollOverview from "./views/TwoFactorEnrollOverview.js";
import TwoFactorSelectMethod from "./views/TwoFactorSelectMethod.js";
import TwoFactorPreActivate from "./views/TwoFactorPreActivate.js";
import TwoFactorConfirm from "./views/TwoFactorConfirm.js";
import TwoFactorOneTimeCodes from "./views/TwoFactorOneTimeCodes.js";
function TwoFactorEnroll(props) {
  const {
    classNames: {
      className,
      warningClassName
    },
    components: {
      ErrorComponent,
      LoadingComponent,
      LogoComponent
    },
    options: {
      getShouldDisplayLogo,
      warningLocation
    },
    variants: {
      variant,
      backToMethodSelectVariant,
      loginLogoVariant,
      warningVariant,
      nextButtonVariant
    },
    state: {
      authenticationData,
      confirmationData,
      error,
      onChangeSelectedTwoFactorMethod,
      onConfirm2FAMethod,
      oneTimeCodes,
      onBackToMethodSelect,
      onNext,
      onPreActivate,
      onSelect2FAMethod,
      selectedTwoFactorMethod,
      setConfirmationData,
      setPreActivateData,
      step,
      twoFactorSettings,
      loading
    }
  } = useTwoFactorEnroll(props);
  const displayLogo = getShouldDisplayLogo(props, 'login/twoFactorEnroll');
  let content;
  switch (step) {
    case TWO_FACTOR_ENROLL_STEPS.OVERVIEW:
      content = /*#__PURE__*/React.createElement(TwoFacterEnrollOverview, {
        onNext: onNext,
        nextButtonVariant: nextButtonVariant
      });
      break;
    case TWO_FACTOR_ENROLL_STEPS.SELECT_METHOD:
      content = /*#__PURE__*/React.createElement(TwoFactorSelectMethod, {
        twoFactorSettings: twoFactorSettings,
        selectedMethod: selectedTwoFactorMethod,
        onChangeSelectedTwoFactorMethod: onChangeSelectedTwoFactorMethod,
        onSelect2FAMethod: onSelect2FAMethod
      });
      break;
    case TWO_FACTOR_ENROLL_STEPS.PRE_ACTIVATE:
      content = /*#__PURE__*/React.createElement(TwoFactorPreActivate, {
        selectedMethod: selectedTwoFactorMethod,
        setPreActivateData: setPreActivateData,
        onPreActivate: onPreActivate,
        onBackToMethodSelect: onBackToMethodSelect,
        backToMethodSelectVariant: backToMethodSelectVariant
      });
      break;
    case TWO_FACTOR_ENROLL_STEPS.CONFIRM:
      content = /*#__PURE__*/React.createElement(TwoFactorConfirm, {
        loading: loading,
        LoadingComponent: LoadingComponent,
        confirmationData: confirmationData,
        setConfirmationData: setConfirmationData,
        selectedMethod: selectedTwoFactorMethod,
        authenticationData: authenticationData,
        onConfirm2FAMethod: onConfirm2FAMethod,
        onBackToMethodSelect: onBackToMethodSelect,
        backToMethodSelectVariant: backToMethodSelectVariant
      });
      break;
    case TWO_FACTOR_ENROLL_STEPS.ONE_TIME_CODES:
      content = /*#__PURE__*/React.createElement(TwoFactorOneTimeCodes, {
        loading: loading,
        LoadingComponent: LoadingComponent,
        oneTimeCodes: oneTimeCodes,
        onNext: onNext,
        nextButtonVariant: nextButtonVariant
      });
      break;
    default:
      content = null;
  }
  return /*#__PURE__*/React.createElement(Pane, {
    variant: variant,
    className: classnames(className, S.pane),
    layout: "flex:colS"
  }, twoFactorSettings === undefined && /*#__PURE__*/React.createElement("div", {
    className: S.blocker
  }, /*#__PURE__*/React.createElement(LoadingComponent, {
    color: "var(--color-brand500)",
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%'
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    inline: true,
    variant: "colM",
    align: "center"
  }, displayLogo && LogoComponent ? /*#__PURE__*/React.createElement(LogoComponent, {
    variant: loginLogoVariant
  }) : null, warningLocation === 'top' && ErrorComponent && step !== TWO_FACTOR_ENROLL_STEPS.CONFIRM ? /*#__PURE__*/React.createElement(ErrorComponent, {
    variant: warningVariant,
    className: warningClassName,
    error: error
  }) : null, content));
}
TwoFactorEnroll.propTypes = {
  variants: PropTypes.exact({
    variant: PropTypes.string,
    backToMethodSelectVariant: PropTypes.string,
    nextButtonVariant: PropTypes.string
  })
};
export default connect(state => {
  return {
    auth: state.auth
  };
})(TwoFactorEnroll);